<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="title">超级管理员信息</div>
      <blue-title class="style">超级管理员信息</blue-title>
      <div>
        <div class="info">
          <span class="marRight">超级管理员身份</span><span>{{ superAdminData.identity }}</span>
        </div>
        <div class="info">
          <span class="marRight">超级管理员姓名</span><span>{{ superAdminData.contactName }}</span>
        </div>
        <div class="info">
          <span class="marRight">超级管理员身份证件号</span><span>{{ superAdminData.contactIdNumber }}</span>
        </div>
        <div class="info">
          <span class="marRight">超级管理员微信Oppenid</span><span>{{ superAdminData.openid }}</span>
        </div>
        <div class="info">
          <span class="marRight">联系手机</span><span>{{ superAdminData.mobilePhone }}</span>
        </div>
        <div class="info">
          <span class="marRight">联系邮箱</span><span>{{ superAdminData.contactEmail }}</span>
        </div>
      </div>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="primary" @click="next">下一页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { draftEcho } from '../../../../api/module/merchants';

export default {
  components: {},
  props: {},
  data() {
    return {
      superAdminData: {},
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
  },
  watch: {},
  created() {
    this.draftEcho();
  },
  methods: {
    back() {
      this.$router.push({
        path: '/merchants',
      });
    },
    next() {
      const { uuid } = this;
      this.$router.push({
        path: '/merchants/supplementDetails',
        query: {
          uuid,
        },
      });
    },
    async draftEcho() {
      const { uuid } = this;
      const result = await draftEcho({
        uuid,
      });
      this.superAdminData = result.superAdministratorInformationVO;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  height: 100%;
  .title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .style {
    font-size: 12px;
    color: #333;
    font-weight: 500;
    margin: 9px 0 20px 0;
  }
  .info {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #333;
    font-weight: 500;
    height: 42px;
    border-bottom: 1px solid #e5e5e5;
  }
  .marRight {
    line-height: 16px;
    width: 90px;
    margin-right: 38px;
  }
  .btn {
    margin-top: 100px;
  }
}
</style>
